import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const PartnerGuard = ({ children }: { children: React.ReactNode }) => {
  const [status, setStatus] = useState<"loading" | "allowed" | "denied">("loading");

  useEffect(() => {
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { setStatus("denied"); return; }

      const { data } = await supabase
        .from("admin_assignments")
        .select("admin_type")
        .eq("user_id", user.id)
        .eq("is_active", true)
        .maybeSingle();

      const allowed = data?.admin_type === "franchisee";
      setStatus(allowed ? "allowed" : "denied");
    })();
  }, []);

  if (status === "loading") {
    return (
      <div className="flex items-center justify-center h-screen">
        Checking partner permissions…
      </div>
    );
  }
  if (status === "denied") return <Navigate to="/" replace />;
  return <>{children}</>;
};

export default PartnerGuard;
